export default "__VITE_ASSET__D5_Jy7MZ__"